/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as styles from './style';

import _ = require("lodash");
import { ISet, IMicrocycleError } from "../../../../containers/FitnessPlan/FitnessTemplate/interface";
import { WorkoutPhaseWidget } from "../WorkoutPhase/WorkoutPhaseWidget";
import { getSetValue } from "../../../../containers/FitnessPlan/FitnessTemplate/helper";
import { DragDropContext } from 'react-beautiful-dnd';


interface IWorkoutWigetProps {
    selectedDayWods: any;
    exerciseList: any;
    setMicrocyleDataForSelectedDay: (data: any) => void;
    errorStates: IMicrocycleError[];
    isViewMode: boolean;
}

export const WorkoutWidget: React.FC<IWorkoutWigetProps> = (props: IWorkoutWigetProps) => {
    const { selectedDayWods, exerciseList, setMicrocyleDataForSelectedDay, errorStates, isViewMode } = props;

    const preWods: ISet[] = _.get(selectedDayWods, 'sets', []);

    const workoutSets: any = _.groupBy(preWods, (item) => item.blockType);

    const handleWorkoutHeaderChange = (data: any, workoutPhase: string, selectedMovementIndex: number | string) => {
        workoutSets[workoutPhase][selectedMovementIndex] = data;

        let combinedWorkoutPhases = Object.keys(workoutSets).reduce((result, phaseName) => {
            // //check for workout with 0 exercises
            if (workoutSets[phaseName].length > 1) {
                const noExercisesIndex = workoutSets[phaseName].findIndex(wrkout => wrkout.managedExercises.length === 0);
                if (noExercisesIndex > -1) {
                    workoutSets[phaseName].splice(noExercisesIndex, 1);
                }
            }
            return result.concat(workoutSets[phaseName]);
        }, []);

        setMicrocyleDataForSelectedDay(combinedWorkoutPhases);
    }

    const handleAddSection = (workoutPhase: string) => {
        const newWorkoutSet = getSetValue(workoutPhase);
        const copiedWorkoutSet = [...selectedDayWods.sets];
        copiedWorkoutSet.push(newWorkoutSet);
        setMicrocyleDataForSelectedDay(copiedWorkoutSet);
    }

    const onDragEnd = (result: any) => {
        if (!result.destination) return;
        const { source, destination } = result;

        //dragging from one section to another
        if (source.droppableId != destination.droppableId) {
            const sourceWorkoutMovements = getBlockTypeDetailsByIndex(source.droppableId);
            const sourceMovements = { ...workoutSets[sourceWorkoutMovements.phaseType][sourceWorkoutMovements.phaseIndex] };
            const sourceExercises = sourceMovements.managedExercises;
            const destinationWorkoutMovements = getBlockTypeDetailsByIndex(destination.droppableId);
            const destinationMovements = { ...workoutSets[destinationWorkoutMovements.phaseType][destinationWorkoutMovements.phaseIndex] };
            const destinationExercises = destinationMovements.managedExercises;

            const [removed] = sourceExercises.splice(source.index, 1);
            destinationExercises.splice(destination.index, 0, removed);

            sourceMovements.managedExercises = sourceExercises;
            destinationMovements.managedExercises = destinationExercises;

            // this is done to avoid duplication of items if all the items from first section are moved to second
            if ((sourceWorkoutMovements.phaseIndex < destinationWorkoutMovements.phaseIndex) && sourceMovements.managedExercises.length === 0) {
                handleWorkoutHeaderChange(sourceMovements, sourceWorkoutMovements.phaseType, sourceWorkoutMovements.phaseIndex)
            }
            else {
                handleWorkoutHeaderChange(sourceMovements, sourceWorkoutMovements.phaseType, sourceWorkoutMovements.phaseIndex)
                handleWorkoutHeaderChange(destinationMovements, destinationWorkoutMovements.phaseType, destinationWorkoutMovements.phaseIndex)
            }
        }
        else {
            //dragging within the same section
            let workoutDetails = getBlockTypeDetailsByIndex(source.droppableId);
            const copiedWorkoutMovememt = workoutSets[workoutDetails.phaseType][workoutDetails.phaseIndex]
            const copiedExercises = [...copiedWorkoutMovememt.managedExercises];
            const [removed] = copiedExercises.splice(source.index, 1);
            copiedExercises.splice(destination.index, 0, removed);
            copiedWorkoutMovememt.managedExercises = copiedExercises;
            handleWorkoutHeaderChange(copiedWorkoutMovememt, workoutDetails.phaseType, workoutDetails.phaseIndex)
        }
    }

    const getBlockTypeDetailsByIndex = (value: string) => {
        const splitValues = value.split("_");
        const phaseType = splitValues[2];
        const phaseIndex = splitValues[1];
        return { phaseType, phaseIndex };
    }

    return (
        <div>
            {
                workoutSets && Object.keys(workoutSets).map((workout: string, index: number) => {
                    return (
                        <div css={styles.workoutOuterWrapper} key={`${workout}-${index}`}>
                            {
                                <DragDropContext onDragEnd={(result: any) => onDragEnd(result)}>
                                    {
                                        workoutSets[workout].map((workoutPhase: any, innerIndex: number) => {
                                            const currentWorkoutPhaseErrors = errorStates && errorStates.filter(({ workoutIndex, phase }) => (workoutIndex === innerIndex && phase === workout))
                                            return (
                                                <WorkoutPhaseWidget selectedWorkoutPhase={workoutPhase}
                                                    handleWorkoutPhaseChange={(e: any) => handleWorkoutHeaderChange(e, workout, innerIndex)}
                                                    exerciseList={exerciseList}
                                                    addSection={handleAddSection} outerIndex={innerIndex}
                                                    key={`movement-${innerIndex}`}
                                                    errorStates={currentWorkoutPhaseErrors}
                                                    isViewMode={isViewMode}
                                                />
                                            )
                                        })
                                    }
                                </DragDropContext>
                            }
                        </div>
                    )
                })
            }
        </div>
    )
}